import { useEffect, useState } from "react";

export function useDebounce(value: string, delay: number, minLength = 0): string {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const trimmed = value.trim();
    if (trimmed.length < minLength) {
      setDebounced("");
      return;
    }
    const id = setTimeout(() => setDebounced(trimmed), delay);
    return () => clearTimeout(id);
  }, [value, delay, minLength]);

  return debounced;
}
